import * as swcHelpers from '@swc/helpers';
import { Util } from '@grandvisionhq/forms';
import { idleState, uninitState, failedState, successState, loadingState } from '@grandvisionhq/state';
import { FETCH_LIST_FAILED, FETCH_LIST_SUCCESS, FETCH_LIST, FETCH_PRODUCT_DATA_SUCCESS, FETCH_PRODUCT_DATA_FAILED, FETCH_PRODUCT_DATA, QUANTITY_SUCCESS, QUANTITY_FAILED, QUANTITY, PAUSE_SUCCESS, PAUSE_FAILED, PAUSE, SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN, SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE, SUBSCRIPTION_ADDRESS_SAVE_FAILED, SUBSCRIPTION_ADDRESS_SAVE_SUCCESS, SUBSCRIPTION_ADDRESS_SAVE, SUBSCRIPTION_ADDRESS_RESET, SUBSCRIPTION_ADDRESS_UPDATE, FETCH_DETAIL_SUCCESS, FETCH_DETAIL_FAILED, FETCH_DETAIL } from './actions.js';

const initialState = {
    detailCall: idleState(),
    pauseCall: idleState(),
    quantityCall: idleState(),
    productDataCall: idleState(),
    productData: {},
    subscriptionForm: {
        state: {},
        saveFormCall: idleState(),
        isInEditMode: false,
        isModalOpen: false
    },
    list: uninitState()
};
const getFormState = (address = {})=>{
    const { streetName , addressLine1 , addressLine2 , addressLine3 , additionalStreetInfo , additionalAddressInfo , county , region  } = address, rest = swcHelpers.objectWithoutProperties(address, [
        "streetName",
        "addressLine1",
        "addressLine2",
        "addressLine3",
        "additionalStreetInfo",
        "additionalAddressInfo",
        "county",
        "region"
    ]);
    const mappedAddress = swcHelpers.objectSpread({}, rest, {
        streetName: streetName || addressLine1 || '',
        additionalStreetInfo: additionalStreetInfo || addressLine2 || '',
        additionalAddressInfo: additionalAddressInfo || addressLine3 || '',
        region: region || county || ''
    });
    return Util.fieldsToFormState(mappedAddress);
};
function subscriptionsReducer(state = initialState, action) {
    switch(action.type){
        case FETCH_DETAIL:
            let detail = state.detail;
            /* Reset detail data when it's for a different subscription. We still want to re-fetch
       * the subscription because it might have been updated since the last fetch.
       * We can still display the old data until the new data is fetched though
       * so we will just replace it when the call succeeds but until then we leave the old data
       */ if (detail && detail.id !== action.payload.subscriptionId) {
                detail = undefined;
            }
            return swcHelpers.objectSpread({}, state, {
                detailCall: loadingState(),
                detail
            });
        case FETCH_DETAIL_FAILED:
            return swcHelpers.objectSpread({}, state, {
                detailCall: failedState(action.error),
                detail: undefined
            });
        case FETCH_DETAIL_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                detailCall: idleState(),
                detail: action.payload,
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    state: getFormState(action.payload.deliveryAddress)
                })
            });
        case SUBSCRIPTION_ADDRESS_UPDATE:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    state: action.payload
                })
            });
        case SUBSCRIPTION_ADDRESS_RESET:
            var ref;
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, initialState.subscriptionForm, {
                    state: getFormState((ref = state.detail) === null || ref === void 0 ? void 0 : ref.deliveryAddress)
                })
            });
        case SUBSCRIPTION_ADDRESS_SAVE:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    saveFormCall: loadingState()
                })
            });
        case SUBSCRIPTION_ADDRESS_SAVE_SUCCESS:
            var ref1;
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, initialState.subscriptionForm, {
                    state: getFormState((ref1 = state.detail) === null || ref1 === void 0 ? void 0 : ref1.deliveryAddress),
                    isModalOpen: true
                })
            });
        case SUBSCRIPTION_ADDRESS_SAVE_FAILED:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    saveFormCall: failedState(action.error)
                })
            });
        case SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    isInEditMode: action.payload
                })
            });
        case SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    isModalOpen: action.payload
                })
            });
        case PAUSE:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: loadingState()
            });
        case PAUSE_FAILED:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: failedState(action.error)
            });
        case PAUSE_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: idleState()
            });
        case QUANTITY:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: loadingState()
            });
        case QUANTITY_FAILED:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: 'reason' in action.payload ? idleState() : failedState(action.payload)
            });
        case QUANTITY_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: idleState()
            });
        case FETCH_PRODUCT_DATA:
            return swcHelpers.objectSpread({}, state, {
                productDataCall: loadingState(),
                productData: swcHelpers.objectSpread({}, state.productData, action.payload.productIds.reduce((acc, id)=>swcHelpers.objectSpread({}, acc, {
                        [id]: loadingState()
                    })
                , {}))
            });
        case FETCH_PRODUCT_DATA_FAILED:
            const { error , productData  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                productDataCall: failedState(error),
                productData: swcHelpers.objectSpread({}, state.productData, productData)
            });
        case FETCH_PRODUCT_DATA_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                productDataCall: idleState(),
                productData: swcHelpers.objectSpread({}, state.productData, action.payload.productData)
            });
        case FETCH_LIST:
            return swcHelpers.objectSpread({}, state, {
                list: loadingState()
            });
        case FETCH_LIST_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                list: successState(action.payload)
            });
        case FETCH_LIST_FAILED:
            return swcHelpers.objectSpread({}, state, {
                list: failedState(action.error)
            });
        default:
            return state;
    }
}

export { initialState, subscriptionsReducer };
//# sourceMappingURL=reducer.js.map
